import { render, staticRenderFns } from "./BrandTheme.vue?vue&type=template&id=3b5e2d4e"
import script from "./BrandTheme.vue?vue&type=script&lang=ts"
export * from "./BrandTheme.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports